import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

/**
 * HelpContext lets any page set a custom WhatsApp help message
 * (e.g., "Bonjour, j'ai une question sur la formation X").
 * If no custom message is set, the floating button infers context from pathname.
 */
const Ctx = createContext(null);

export function HelpProvider({ children }) {
  const [pageHelp, setPageHelp] = useState(null); // { message: string }

  const setHelp = useCallback((message) => {
    setPageHelp(message ? { message } : null);
  }, []);

  const value = useMemo(() => ({ pageHelp, setHelp }), [pageHelp, setHelp]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useSetHelpMessage(message, deps = []) {
  // Hook for pages: sets the WhatsApp help message while the page is mounted.
  const ctx = useContext(Ctx);
  const set = ctx?.setHelp;
  React.useEffect(() => {
    if (!set) return;
    set(message);
    return () => set(null);
    // eslint-disable-next-line
  }, deps);
}

export const useHelp = () => useContext(Ctx);
